import { render, staticRenderFns } from "./detail-dialog.vue?vue&type=template&id=3ee81ea4&scoped=true"
import script from "./detail-dialog.vue?vue&type=script&lang=js"
export * from "./detail-dialog.vue?vue&type=script&lang=js"
import style0 from "./detail-dialog.vue?vue&type=style&index=0&id=3ee81ea4&prod&lang=less&scoped=true"
import style1 from "./detail-dialog.vue?vue&type=style&index=1&id=3ee81ea4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee81ea4",
  null
  
)

export default component.exports